import { PieChart } from '@opd/g2plot-react';
import { Flex } from 'antd';
import { useMemo } from 'react';

import CustomLegendData from './CustomLegendData';

import useMediaQuery from 'hooks/useMediaQuery';

import type { PlantingGroupStageCount } from 'screens/season-overview/types';

const CHART_COLORS_IN_ORDER = ['#4096FF', '#73D13D', '#FFA940', '#00000026'];

const PlantingGroupStageChart = ({
  onboarding,
  planting,
  collections,
  closed,
}: PlantingGroupStageCount) => {
  const isSmallScreen = useMediaQuery('(max-width: 766px)');

  const data = useMemo(
    () => [
      // { type: 'Pending', value: notShipped },
      {
        type: 'Onboarding',
        value: onboarding || 0,
      },
      {
        type: 'Planting',
        value: planting || 0,
      },
      {
        type: 'Collections',
        value: collections || 0,
      },
      {
        type: 'Closed',
        value: closed || 0,
      },
    ],
    [onboarding, planting, collections, closed],
  );

  const config = useMemo(
    () => ({
      appendPadding: 0,
      data,
      angleField: 'value',
      colorField: 'type',
      radius: 1,
      innerRadius: 0.75,
      color: CHART_COLORS_IN_ORDER,
      meta: {
        value: {
          formatter: () => ``, // Empty formatter required for hiding percentages in archs
        },
      },
      label: {
        type: 'inner',
        offset: '-60%',
        autoRotate: false,
        style: { textAlign: 'center' },
      },
      statistic: {
        title: {
          content: 'Total Groups',
          style: {
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.45)',
            lineHeight: '20px',
            fontWeight: 400,
            fontFamily: 'Poppins',
          },
        },
        content: {
          content: `${(onboarding || 0) + (planting || 0) + (collections || 0) + (closed || 0)}`,
          style: {
            fontSize: isSmallScreen ? '15px' : '24px',
            color: 'rgba(0, 0, 0, 0.85)',
            fontFamily: 'Poppins',
          },
        },
      },
    }),
    [data, isSmallScreen, onboarding, planting, collections, closed],
  );

  return (
    <Flex gap={20} align="flex-start" className="piechart-container">
      <PieChart
        width={isSmallScreen ? undefined : 180}
        height={isSmallScreen ? undefined : 150}
        legend={false}
        style={{
          height: '100%',
        }}
        {...config}
      />
      <CustomLegendData
        {...{ onboarding, planting, collections, closed }}
        colorsInOrder={CHART_COLORS_IN_ORDER}
      />
    </Flex>
  );
};

export default PlantingGroupStageChart;
